import { useQuery } from "react-query";
import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import type { Event, FormScheduleValues } from "@circle-react/types";

interface CalculateScheduleParams {
  event: Event;
  formScheduleValues: FormScheduleValues;
}

export const useCalculateSchedule = (params?: CalculateScheduleParams) => {
  const { event, formScheduleValues } = params || {};
  const { startsAt, endsAt, frequency } = formScheduleValues || {};

  return useQuery({
    queryKey: ["calculateSchedule", event?.id, formScheduleValues],
    queryFn: async () => {
      if (!event || !startsAt || !endsAt || !frequency) {
        return null;
      }

      const apiParams = {
        event: {
          frequency,
          starts_at: startsAt,
          event_ends_at: endsAt,
        },
      };

      return reactQueryGet(
        internalApi.events.calculateSchedule({
          slug: event.slug,
          spaceId: event.space_id,
          params: apiParams,
        }),
      );
    },
    enabled: !!(event && startsAt && endsAt && frequency),
  });
};
